import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import Typography from "@mui/material/Typography";
const PropertyField = ({
  classes,
  title,
  children,
  basicStyles
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: basicStyles ? classes.flex : classes.fieldItem
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.nameTitle
  }, title), children);
};
const styles = () => ({
  fieldItem: {
    display: "flex",
    flex: 1,
    paddingTop: 4,
    paddingBottom: 4,
    alignItems: "center",
    minHeight: 32
  },
  nameTitle: {
    fontWeight: 500,
    minWidth: "35%",
    alignSelf: "center",
    marginRight: 8
  },
  flex: {
    display: "flex"
  }
});
export default withStyles(styles)(PropertyField);
PropertyField.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.node]),
  basicStyles: PropTypes.bool
};
PropertyField.defaultProps = {
  basicStyles: false
};